import { Additional_Permissions } from '../../permissions.token';

export const PROVIDER = { provide: Additional_Permissions, useValue: null };
